import React, { useState } from 'react';
import { BrowserRouter, Route, Switch, Link } from "react-router-dom";
import "./Admin.css";
import ListUsers from './ListUsers';
import UserDetail from './UserDetail';
import RoomDetail from './RoomDetail';

const AdminIndex = () => {
    return <>
        <h2>ADMIN TOOLS</h2>
        <Switch> 
            <Route path="/admin/users/:user_id">
                <UserDetail />
            </Route>
            <Route path="/admin/rooms/:room_id">
                <RoomDetail />
            </Route>
            <Route path="/admin" exact>
                <ListUsers />
            </Route>
        </Switch>
    </>
}

export default AdminIndex;